import { forwardRef } from 'react';
import { Flex } from '@chakra-ui/react';
import DropdownMenu from '@/components/DropdownMenu';

const UserSettingsDropDown = forwardRef<HTMLDivElement, any>((props, ref) => (
  <Flex ref={ref} h="100%" align="center" {...props}>
    <DropdownMenu
      items={[
        {
          name: 'Trocar Senha',
          route: 'trocar-senha',
        },
      ]}
    />
  </Flex>
));

export default UserSettingsDropDown;
